import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
import { useEmployeeStore } from '@/stores/employee'
import { useUserStore } from '@/stores/user'
import {
  HOMEPAGE_PAGE_NAME,
  TEAM_MANAGEMENT_PAGE_NAME,
  BOOKINGS_PAGE_NAME,
  COMPANY_SETTINGS_PAGE_NAME,
  LOYALTY_PAGE_NAME
} from '@/constants/gtm-page-names'

const adminAabGuard = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
) => {
  const employeeStore = useEmployeeStore()
  const userStore = useUserStore()

  try {
    const isUserEmpty = Object.keys(userStore.user).length === 0

    if (isUserEmpty) {
      await userStore.refreshUser()
    }

    if (!userStore.isAab) {
      return next({ name: 'dashboard' })
    }

    if (!employeeStore.employee) {
      await employeeStore.setEmployee()
    }

    return employeeStore.isAuthorizedForAab ? next() : next({ name: 'dashboard' })
  } catch {
    return next({ name: 'dashboard' })
  }
}

export const aabRoutes = [
  {
    name: 'aab',
    path: 'aab',
    beforeEnter: adminAabGuard,
    children: [
      {
        path: 'dashboard',
        name: 'aab-dashboard',
        meta: {
          gtmId: 'GTM_AAB_PAGE_DASHBOARD',
          pageName: HOMEPAGE_PAGE_NAME
        },
        component: () => import('../views/aab/DashboardAab.vue')
      },
      {
        path: 'collaborators-management',
        name: 'aab-collaborators-management',
        meta: {
          gtmId: 'GTM_AAB_PAGE_TEAM_MANAGEMENT',
          pageName: TEAM_MANAGEMENT_PAGE_NAME
        },
        component: () => import('../views/aab/CollaboratorsManagementAab.vue')
      },
      {
        path: 'bookings-management',
        name: 'aab-bookings-management',
        meta: {
          gtmId: 'GTM_AAB_PAGE_BOOKINGS',
          pageName: BOOKINGS_PAGE_NAME
        },
        component: () => import('../views/aab/BookingsManagementAab.vue')
      },
      {
        path: 'company-information',
        name: 'aab-company-information',
        meta: {
          gtmId: 'GTM_AAB_PAGE_COMPANY_SETTINGS',
          pageName: COMPANY_SETTINGS_PAGE_NAME
        },
        component: () => import('../views/aab/CompanyInformationAab.vue')
      },
      {
        path: 'loyalty-management',
        name: 'aab-loyalty-management',
        meta: {
          gtmId: 'GTM_AAB_PAGE_LOYALTY',
          pageName: LOYALTY_PAGE_NAME
        },
        component: () => import('../views/aab/LoyaltyManagementAab.vue')
      }
    ]
  }
]
